/**
 * Work Order Status API
 *
 * API client functions for fetching work order status options.
 *
 * Endpoint : GET /jobs/work-order-status-list
 * Method   : GET
 * Backend  : apps/backend/src/domains/works-lite/jobs/work-order-status-list/routes.ts
 */

import { apiClient } from '@/lib/api';
import type { WorkOrderStatusItem } from '@skewb-works/contracts';

// Re-export the shared type so consumers don't need to import from contracts directly
export type { WorkOrderStatusItem };

/**
 * Fetch work order status options for the work orders filter dropdown.
 */
export async function getWorkOrderStatusList(): Promise<WorkOrderStatusItem[]> {
  return apiClient.get<WorkOrderStatusItem[]>('/jobs/work-order-status-list');
}
